export default __webpack_public_path__ + "static/media/lightcloud.3be6b9ca.svg";